<template>
  <ul class="tag-wrap">
    <li
      class="filters__item tag"
      :class="{'tag_active': isFilterAllActive()}"
      @click="onFilterAllClick"
    >
      Все
    </li>
    <li
      v-for="tagItem in filtersTag"
      :key="tagItem"
      class="tag"
      :class="{'tag_active': isFilterActive(tagItem)}"
      @click="() => onFilterItemClick(tagItem)"
    >
      {{ tagItem }}
    </li>
  </ul>
</template>

<script>
const FILTER_TAG = 'filter';

export default {
  name: 'FiltersTag',
  props: {
    filtersTag: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    searchParams: null,
  }),
  beforeMount() {
    this.searchParams = new URLSearchParams(window.location.search);
    window.searchParams = this.searchParams;
  },
  methods: {
    onFilterItemClick(tagItem) {
      this.changeFilters(tagItem);
      this.updateFilter();
    },
    onFilterAllClick() {
      this.searchParams.delete(FILTER_TAG);
      this.updateFilter();
    },
    updateFilter() {
      const filterParams = this.searchParams.get(FILTER_TAG) ? this.searchParams.get(FILTER_TAG).toString() : '';
      this.$emit('change-search-params', filterParams);
      this.pushHistoryApi();
    },
    changeFilters(tagItem) {
      if (this.searchParams.get(FILTER_TAG) === tagItem) {
        this.searchParams.delete(FILTER_TAG);
        return;
      }
      this.searchParams.set(FILTER_TAG, tagItem);
    },
    pushHistoryApi() {
      const searchParamsString = this.searchParams.toString();
      const url = searchParamsString
        ? `${window.location.origin}${window.location.pathname}?${searchParamsString}`
        : `${window.location.origin}${window.location.pathname}`;
      window.history.pushState(window.location.origin, null, url);
    },
    isFilterActive(tagItem) {
      return this.searchParams && this.searchParams.get(FILTER_TAG) && this.searchParams.get(FILTER_TAG).includes(tagItem);
    },
    isFilterAllActive() {
      return !this.searchParams || !this.searchParams.get(FILTER_TAG);
    },
  },
};
</script>
